const summerPromoPage = document.querySelectorAll('.summer-promo');

if (summerPromoPage.length > 0) {

  window.addEventListener('load', () => {

    summerPromoPage.forEach(page => {
      const home = page.querySelector('.summer-promo-home-btn');

      if (home) {
        setTimeout(() => {
          home.classList.add('reveal-top-to-bottom');
        }, 500);
      }
    });

  });
}
